<template>
  <div class="taginput">
    <div class="tagscontainer" @click="open = !open">
      <div v-if="!val.length" class="tagscontainer__placeholder">Укажите страны поездки</div>
      <div class="tagscontainer__inner">
        <Tag @click.stop v-for="v in val" :key="v" :text="v" @remove="removeTag" />
      </div>
      <button class="tagscontainer__clear" v-if="val.length" @click.stop="clear">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 7L17 17M7 17C7.22222 17 13.7593 10.3333 17 7" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <button class="tagscontainer__open" :class="{ 'active': open }" @click.stop="open = !open">
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.5L6 6.5L11 1.5" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <ul class="tagscontainer__list" @click.stop role="listbox" v-if="open">
        <li role="option" v-for="(option, index) in options" :key="option + '-' + index" @click="addCountry(option)" @keydown.enter.space="addCountry(v)" :tabindex="$store.getters.loading ? -1 : 0">{{ option }}</li>
      </ul>
    </div>
    <div class="tagsoptions">
      <div v-if="!allpicked" class="tagsoptions__content">
        <div class="tagsoptions__main">
          <div role="button" v-for="v in options" :key="v" @click="curvalue.add(v)">{{ v }}</div>
        </div>
        <div role="button" class="tagsoptions__all" @click="allpicked = true">{{ allvalue }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Tag from './Tag.vue'
import FormField from '../../mixins/FormField.vue'
export default {
  components: { Tag },
  data: () => ({
    open: false,
    curvalue: new Set(),
    allpicked: false
  }),
  mixins: [FormField],
  props: {
    modelValue: { type: Array, default: () => [] },
    placeholder: { type: String },
    required: { type: Boolean },
    allvalue: { type: String, required: true },
    values: { type: Array, required: true },
    name: { type: String, required: true }
  },
  methods: {
    addCountry(c) {
      this.curvalue.add(c)
      this.open = false
    },
    clear() {
      this.allpicked = false
      this.curvalue = new Set()
    },
    removeTag(text) {
      if (text == this.allvalue)
        return this.allpicked = false
      this.curvalue.delete(text)
    }
  },
  computed: {
    val() {
      if (this.allpicked) return [this.allvalue]
      else return [...this.curvalue]
    },
    options() {
      let res = new Set(this.values),
        cv = new Array(...this.curvalue)
      for (let v of cv)
        res.delete(v)
      return [...res]
    },
    error() {
      if (this.required && !this.modelValue) return 'заполните поле'
      return ''
    }
  },
  watch: {
    val(v, old) {
      this.$emit('update:modelValue', v)
      if (v.length != old.length)
        this.$store.dispatch('callAction', this.name)
    },
    error(v) {
      this.$emit('error', v)
    }
  }
}
</script>

<style lang="sass" scoped>
.tagscontainer
  cursor: pointer
  min-height: 55px
  padding: 13px 16px 11px
  border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
  transition: border-color .1s ease-out
  display: flex
  align-items: flex-start
  position: relative
  z-index: 2
  &.filled
    border-bottom: 1px solid colors.$newgray
    box-shadow: 0px 1px 0px 0px colors.$newgray
  &__placeholder
    font-size: 16px
    line-height: 1.12
    color: colors.$newgray
    position: absolute
    left: 16px
    bottom: 17px
  &__list
    display: block
    width: 100%
    position: absolute
    z-index: 1
    top: calc(100% + 2px)
    left: 0
    background: colors.$mainbg
    padding: 0
    margin: 0
    box-shadow: 0 2px 5px rgba(0,0,0,.2)
    li
      display: block
      outline: none
      cursor: pointer
      color: colors.$newgray
      font-size: 18px
      line-height: 26px
      padding: 10px 18px
      &:hover, &:focus
        background: colors.$newestsilver

  &__inner
    display: flex
    flex-wrap: wrap
    margin: -5px -4px -4px
    >*
      margin: 4px
  &__open
    width: 16px
    height: 16px
    display: flex
    align-items: center
    justify-content: center
    margin-left: auto
    margin-right: 4px
    transform: translateY(6px)
    &:focus-visible
      border: 1px solid rgba(0,0,0,.5)
      border-radius: 5px
    &.active
      transform: translateY(6px) scaleY(-1)
  &__clear
    margin-left: auto
    transform: translateY(2px)
    & + .tagscontainer__open
      margin-left: 20px

.tagsoptions
  color: colors.$newred
  font-size: 14px
  line-height: 1.12
  margin-top: 17px
  height: 16px
  white-space: nowrap
  [role=button]
    cursor: pointer
  &__content
    display: flex
  @include from(440px)
    margin-top: 8px

  &__main
    display: flex
    overflow: hidden
    flex-wrap: wrap
    height: 16px
    >*
      margin-right: 16px
  &__all
    flex-shrink: 0
    position: relative
    z-index: 1
    &::before
      content: ''
      position: absolute
      left: -16px
      top: 0
      height: 100%
      width: 16px
      background: colors.$mainbg
      z-index: -1


</style>